import styled from 'styled-components'
import { colors, fonts } from '../Styles/common-styles'

const H1 = styled.h1`
display: flex;
font-size: ${fonts.extraLargeSize};
font-weight: 600;
line-height: ${fonts.extraLargeSize};
color: ${colors.black};
`
const TitlePlus = styled.div`
display: flex;
font-size: ${fonts.bigSize};
font-weight: 600;
margin: 1%;
line-height: 22.4px;
color: ${colors.black}
`

const Title = styled.div`
display: flex;
font-size: ${fonts.largeSize};
font-weight: ${props => props.bolded ? 600 : 400};
line-height: 22.4px;
color: ${colors.black};
margin: 22px 0px;
`
const SmallTitle = styled.div`
display: flex;
font-size: ${fonts.largeSize};
font-weight: ${props => props.bolded ? 600 : 400};
color: ${props => props.colored ? `${colors.purpleMain}` : `${colors.$black}`};
text-align: ${props => props.centered ? 'center' : 'justify'};
margin: 2%;
margin-bottom: 8px;
`
const Button = styled.div`
  color: ${props => props.bordered ? `${colors.purpleMain}` : `${colors.white}`};
  background: ${props => props.bordered ? `${colors.white}` : props.saved ? `${colors.pink}` : `${colors.purpleMain}`};
  border: ${props => props.bordered ? `2px solid ${colors.purpleMain}` : 'none'};
  padding: 8px 12px;
  border-radius: 8px;
  text-align: center;
  margin: auto;
  cursor: pointer;
  &:hover {
    background: ${props => props.bordered ? `${colors.purpleMain}` : null};
    color: ${props => props.bordered ? `${colors.white} !important` : null};
    stroke: ${colors.white} !important;
  }
  & a:hover {
    cursor: pointer;
    color: ${props => props.bordered ? `${colors.white} !important` : null};
  }
`
const IconButton = styled.div`
  border: ${props => props.bordered ? `2px solid ${colors.purpleMain}` : props.greyed ? `2px solid ${colors.grey}` : 'none'};
  color: ${props => props.greyed ? `${colors.grey}` : `${colors.purpleMain}`};
  padding: 8px 12px;
  border-radius: 8px;
  text-align: center;
  margin: auto;
`
const StartButton = styled.button`
  background: ${colors.purpleMain};
  border-radius: 8px;
  color: ${colors.white};
  margin: 0px 8px;
  width: 71px;
  height: 40px;
  cursor: pointer;
  &:hover {
    background: ${colors.purpleBright};
  }
`
const Back = styled.button`
    font-size: ${fonts.largeSize};
    color: ${props => props.colored ? `${colors.purpleMain}` : `${colors.black}`};
    padding-bottom: ${props => props.padded ? '5px' : 'none'};
    font-weight: 600;
    line-height: 20px;
    align-items: center;
    background-color: transparent;
`
const InlineFlex = styled.div`
  display: inline-flex;
  justify-content: space-between;
  `
const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  width:100%;
  overflow: hidden;
`
const Image = styled.img`
  display: flex;
  margin: auto;
  vertical-align: middle;
  text-align: center;
`
const P = styled.div`
  margin: 10% auto;
  font-size: ${fonts.largePlusSize};
  font-weight: 400;
  line-height: 190%;
  color: ${colors.black};
  text-align: center;
`
const SmallText = styled.div`
  font-size: ${fonts.smallSize};
  font-weight: normal;
  line-height: 140%;
  color: ${colors.grey};
`
const NormalText = styled.div`
  font-size: ${fonts.normalSize};
  color: ${props => props.colored ? `${colors.purpleMain}` : props.greyed ? `${colors.grey}` : `${colors.$black}`};
  text-align: ${props => props.centered ? 'center' : 'justify'};
  font-weight: normal;
  line-height: 140%;
  margin: 1%;
`
const SpanText = styled.span`
  color: ${props => props.colored ? `${colors.purpleMain}` : `${colors.$grey}`};
  font-size: ${props => props.large ? `${fonts.largeSize}` : `${fonts.normalSize}`};;
`

const AddActivity = styled.div`
  width: 270px;
  height: 290px;
  margin: 14px;
  background: ${colors.background};
  border: 1px solid ${colors.purpleMain};
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
  `
const PinkSpan = styled.span`
  color: ${colors.pink};
`
const Card = styled.div`
    background: ${colors.white};
    margin: 14px;
    width: 270px;
    height: 290px;
    border: 1px solid ${colors.stroke};
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
`
const TimelineImage = styled.div`
    position: relative;
    width: 270px;
    height: 140px;
    overflow: hidden;
`
export {
  P, Button, H1, Title, TitlePlus, SmallTitle, SmallText, SpanText, Card, NormalText, Back,
  Image, TimelineImage, InlineFlex, FlexWrapper, AddActivity, IconButton, PinkSpan, StartButton
}
